var _path, _g, _path2, _path3, _path4, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4062 5H10.0903C9.00546 5 7.96509 5.43094 7.19801 6.19801C6.43094 6.96509 6 8.00546 6 9.09027V41.8124C6 42.8972 6.43094 43.9376 7.19801 44.7047C7.96509 45.4718 9.00546 45.9027 10.0903 45.9027H34.6319C35.7167 45.9027 36.7571 45.4718 37.5242 44.7047C38.2912 43.9376 38.7222 42.8972 38.7222 41.8124V19.3159L24.4062 5Z",
    fill: "url(#paint0_linear_7240_24272)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7240_24272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4062 5V17.5202C24.4062 18.512 25.2102 19.3159 26.202 19.3159H38.7222",
    fill: "url(#paint1_linear_7240_24272)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1201 47C37.1201 47 45.2608 42.9297 45.2608 36.8242V29.7012L37.1201 26.6484L28.9795 29.7012V36.8242C28.9795 42.9297 37.1201 47 37.1201 47Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1201 47C37.1201 47 45.2608 42.9297 45.2608 36.8242V29.7012L37.1201 26.6484L28.9795 29.7012V36.8242C28.9795 42.9297 37.1201 47 37.1201 47Z",
    fill: "url(#paint2_linear_7240_24272)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6152 35.3279L36.2067 38.9194L42.1925 32.9336",
    stroke: "white",
    strokeWidth: 1.79573,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.9053,
    y: 23.6555,
    width: 14.9644,
    height: 1.79573,
    rx: 0.897864,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9053,
    y: 28.4441,
    width: 8.38007,
    height: 1.79573,
    rx: 0.897864,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7240_24272",
    x: 22.6105,
    y: 4.40142,
    width: 17.9079,
    height: 17.9074,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.19715
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.897864
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7240_24272"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7240_24272",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7240_24272",
    x1: 7.2588,
    y1: 7.19375,
    x2: 40.6878,
    y2: 48.1348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF55F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7240_24272",
    x1: 24.957,
    y1: 5.76781,
    x2: 35.8917,
    y2: 22.5078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF55F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#FF5252"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7240_24272",
    x1: 37.1201,
    y1: 26.6484,
    x2: 37.1201,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DC0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileShield);
export default __webpack_public_path__ + "static/media/icon_file_shield.40aef74b7e5fe73400f32588e6426ab5.svg";
export { ForwardRef as ReactComponent };